import React, { useEffect } from 'react'
import Banner from '../commonComponets/Banner'
import LogistiscScreen from '../componets/logistics/LogistiscScreen'

const Logistics = () => {


  useEffect(()=>{
    //document.title = "Logistics"
},[])

    return (
        <>
          <Banner title="Logistics" />
          <LogistiscScreen/>
        </>
    )
}

export default Logistics
